import { geometry } from '@turf/helpers';

import { Plot } from '@/api/rest/resources/types/plot';

export const getGeometriesForPlots = (plots: Plot[]) => {
  return plots.map((plot) => geometry('MultiPolygon', plot.multi_polygon.coordinates));
};
